"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isHex = void 0;
const ethers_1 = require("ethers");
function isHex(hex, size = 0) {
    let result = ethers_1.utils.isHexString(hex);
    if (result && size > 0) {
        result = hex.length === size * 2 + 2;
    }
    return result;
}
exports.isHex = isHex;
